// extracted by mini-css-extract-plugin
export default {"view-img":"PreviewImg_view-img__MYo8o"};